// extracted by mini-css-extract-plugin
export default {"login-view-layout":"AuthViewLayout_login-view-layout__taaV6"};